// eslint-disable-next-line no-unused-vars
import { AxiosResponse } from 'axios';

import axiosInstance from './axiosInstance';

/**
 * @typedef {Object} ResponseGetKriptoPayments
 * @property {Array.<Object>} data - Lista de Kriptopayments
 * @property {Number} current_page - Pagina Actual
 * @property {Number} per_page - Cantidad items por pagina
 * @property {Number} total_pages - Total de paginas
 * @property {Number} total_elements - Total de Items
 */

/**
 * @typedef StatusFilter
 * @type {'request' | 'wait' | 'received' | 'complete' | 'cancel' | 'pending_by_validate'}
 */

/**
 * @typedef {Object} FiltersObjectGetKriptoPayments
 * @property {Number} [perPage] - Cantidad de recursos por pagina
 * @property {Number} [page] - Pagina Actual
 * @property {'created_at'} [column] - Orden por columna
 * @property {'ASC' | 'DESC'} [orderColumn] - Orden por sentido
 * @property {Number | String} [merchantId] - Buscar por un merchant
 * @property {Number | String} [clientId] - Buscar por un cliente
 * @property {StatusFilter} status - Buscar por estado
 */

/**
 * Obtener las lista de Kriptopayments
 * @param {FiltersObjectGetKriptoPayments} [filters] - Filtros
 * @returns {Promise<AxiosResponse<ResponseGetKriptoPayments>>} Listado de Kriptopayments
 */

const getKriptoPayments = (filters = {}) => {
  const {
    perPage,
    page,
    column = 'created_at',
    orderColumn = 'DESC',
    merchantId,
    clientId,
    status,
  } = filters;

  return axiosInstance.get('/internal/admin/kriptopayments', {
    params: {
      per_page: perPage,
      page,
      column,
      order_column: orderColumn,
      merchant_id: merchantId,
      client_id: clientId,
      state: status,
    },
  });
};

export default getKriptoPayments;
